export const CyPlaylist = {
  ButtonRemove: "ButtonRemove",
  ButtonDoneAdding: "ButtonDoneAdding",
  AlertUnknownSongs: "AlertUnknownSongs",
  Title: "PlaylistTitle",
} as const;
